/**
 * 匿名コンサルホットラインの詳細画面のテキスト
 */
export const hotlineProfessionalDetailText = {
    /**
     * 項目の名前
     */
    label: {
        phone: () => 'Web会議がつながらないときの電話番号',
        timeSchedule: () => '当日のタイムスケジュール',
    },
};
